<template>
  <div v-if="error">
    <div v-if="error === RoomErrors.UNAUTHORIZED" class="mb-3">
      {{ $t('errorText') }}
    </div>
  </div>
</template>

<script>
import useRoom from '@/compositions/useRoom';
import { RoomErrors } from '@/enums';

export default {
  name: 'VideoRoomError',
  setup() {
    const { error } = useRoom();

    return {
      error,
      RoomErrors,
    };
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
errorText: 'Error: invalid authorization url'
</i18n>

<i18n locale="ru" lang="yaml">
errorText: 'Ошибка: неверный url авторизации'
</i18n>
